import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=00acb5ea"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "./orderList.vue?vue&type=style&index=0&id=00acb5ea&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00acb5ea')) {
      api.createRecord('00acb5ea', component.options)
    } else {
      api.reload('00acb5ea', component.options)
    }
    module.hot.accept("./orderList.vue?vue&type=template&id=00acb5ea", function () {
      api.rerender('00acb5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/thirdSam/orderList.vue"
export default component.exports